import { render, staticRenderFns } from "./DocumentLayoutAnalysisView.vue?vue&type=template&id=1deba3f2&scoped=true&"
import script from "./DocumentLayoutAnalysisView.vue?vue&type=script&lang=js&"
export * from "./DocumentLayoutAnalysisView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLayoutAnalysisView.vue?vue&type=style&index=0&id=1deba3f2&prod&scoped=true&lang=css&"
import style1 from "./DocumentLayoutAnalysisView.vue?vue&type=style&index=1&id=1deba3f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deba3f2",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QSpace,QExpansionItem,QFile,QIcon,QSeparator,QToolbar,QBtnGroup,QSlider,QCheckbox,QTooltip,QDialog,QCard,QCardSection,QItemLabel,QItem,QCardActions,QInnerLoading,QSpinnerFacebook});qInstall(component, 'directives', {ClosePopup});
